// get list of payment method types and possible details

import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PaymentMethodDetail, PaymentMethodType } from './types';

type Response = {
  methodTypes: Array<{
    type: PaymentMethodType;
    detail: PaymentMethodDetail;
  }>;
};

export default (makeCall: MakeCall) => () =>
  makeCall<Response>('GET', `${APIV2_URL}/payment/method-types`);
